module.exports = __webpack_public_path__ + "img/conference-in.fb94a64a.png";